var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H42.3421V42.3421H0V0ZM2 2V40.3421H40.3421V2H2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3514 24.3564H7.90771V35.0957H14.3514V24.3564Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1296 27.7933C12.9089 27.7933 14.3514 26.3508 14.3514 24.5715C14.3514 22.7921 12.9089 21.3496 11.1296 21.3496C9.35018 21.3496 7.90771 22.7921 7.90771 24.5715C7.90771 26.3508 9.35018 27.7933 11.1296 27.7933Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1296 38.1029C12.9089 38.1029 14.3514 36.6604 14.3514 34.881C14.3514 33.1016 12.9089 31.6592 11.1296 31.6592C9.35018 31.6592 7.90771 33.1016 7.90771 34.881C7.90771 36.6604 9.35018 38.1029 11.1296 38.1029Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2318 24.3564H17.7881V35.0957H24.2318V24.3564Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0099 27.7933C22.7893 27.7933 24.2318 26.3508 24.2318 24.5715C24.2318 22.7921 22.7893 21.3496 21.0099 21.3496C19.2306 21.3496 17.7881 22.7921 17.7881 24.5715C17.7881 26.3508 19.2306 27.7933 21.0099 27.7933Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0099 38.1029C22.7893 38.1029 24.2318 36.6604 24.2318 34.881C24.2318 33.1016 22.7893 31.6592 21.0099 31.6592C19.2306 31.6592 17.7881 33.1016 17.7881 34.881C17.7881 36.6604 19.2306 38.1029 21.0099 38.1029Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6756 35.0956H27.6689V24.3558H27.6756C27.7311 23.541 28.094 22.7777 28.6908 22.2202C29.2876 21.6626 30.0738 21.3525 30.8905 21.3525C31.7072 21.3525 32.4934 21.6626 33.0902 22.2202C33.687 22.7777 34.0499 23.541 34.1054 24.3558H34.1126V35.0956H34.1054C34.0519 35.9119 33.6899 36.6772 33.0929 37.2363C32.4959 37.7955 31.7085 38.1066 30.8905 38.1066C30.0725 38.1066 29.2852 37.7955 28.6881 37.2363C28.0911 36.6772 27.7291 35.9119 27.6756 35.0956Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7372 32.103H14.3516V30.103H27.7372V32.103Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7372 28.2368H14.3516V26.2368H27.7372V28.2368Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5592 16.1172C11.3491 16.1172 11.1787 16.2875 11.1787 16.4977C11.1787 16.7078 11.3491 16.8781 11.5592 16.8781C11.7693 16.8781 11.9397 16.7078 11.9397 16.4977C11.9397 16.2875 11.7693 16.1172 11.5592 16.1172ZM9.17871 16.4977C9.17871 15.183 10.2445 14.1172 11.5592 14.1172C12.8739 14.1172 13.9397 15.183 13.9397 16.4977C13.9397 17.8124 12.8739 18.8781 11.5592 18.8781C10.2445 18.8781 9.17871 17.8124 9.17871 16.4977Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5592 10.7471C11.3491 10.7471 11.1787 10.9174 11.1787 11.1275C11.1787 11.3377 11.3491 11.508 11.5592 11.508C11.7693 11.508 11.9397 11.3377 11.9397 11.1275C11.9397 10.9174 11.7693 10.7471 11.5592 10.7471ZM9.17871 11.1275C9.17871 9.81284 10.2445 8.74707 11.5592 8.74707C12.8739 8.74707 13.9397 9.81284 13.9397 11.1275C13.9397 12.4422 12.8739 13.508 11.5592 13.508C10.2445 13.508 9.17871 12.4422 9.17871 11.1275Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5592 5.5918C11.3491 5.5918 11.1787 5.76214 11.1787 5.97227C11.1787 6.1824 11.3491 6.35274 11.5592 6.35274C11.7693 6.35274 11.9397 6.1824 11.9397 5.97227C11.9397 5.76214 11.7693 5.5918 11.5592 5.5918ZM9.17871 5.97227C9.17871 4.65757 10.2445 3.5918 11.5592 3.5918C12.8739 3.5918 13.9397 4.65757 13.9397 5.97227C13.9397 7.28697 12.8739 8.35274 11.5592 8.35274C10.2445 8.35274 9.17871 7.28697 9.17871 5.97227Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2847 20.1484C17.3523 20.1484 18.2178 19.283 18.2178 18.2153C18.2178 17.1477 17.3523 16.2822 16.2847 16.2822C15.217 16.2822 14.3516 17.1477 14.3516 18.2153C14.3516 19.283 15.217 20.1484 16.2847 20.1484Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1124 16.2822H16.4995V20.1484H34.1124V16.2822Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2847 14.9937C17.3523 14.9937 18.2178 14.1282 18.2178 13.0605C18.2178 11.9929 17.3523 11.1274 16.2847 11.1274C15.217 11.1274 14.3516 11.9929 14.3516 13.0605C14.3516 14.1282 15.217 14.9937 16.2847 14.9937Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1124 11.1274H16.4995V14.9937H34.1124V11.1274Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2847 9.83887C17.3523 9.83887 18.2178 8.97339 18.2178 7.90576C18.2178 6.83814 17.3523 5.97266 16.2847 5.97266C15.217 5.97266 14.3516 6.83814 14.3516 7.90576C14.3516 8.97339 15.217 9.83887 16.2847 9.83887Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1124 5.97266H16.4995V9.83887H34.1124V5.97266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoMachine);
export default __webpack_public_path__ + "static/media/RoMachine.d2a894891b1975e08de1b224add3a88f.svg";
export { ForwardRef as ReactComponent };